import React from "react";
import { useTranslation } from "react-i18next";
import H4 from "../Titles/h4";
import ButtonFit from "../Buttons/button-fit";

export default function SerenityPackCard({ pricePerDay, onToggle, isAdded, disabled }) {
    const { t } = useTranslation();
    const showPrice = !disabled && Number(pricePerDay) > 0;

    return (
        <div className="w-full border border-main bg-[#faf6ee] p-4 md:p-5 mt-4 mb-12" aria-live="polite">
            <div className="flex items-stretch justify-between gap-4">
                <div className="max-w-[70%]">
                    <H4 title={t("reservation.packSerenity.title")} fontWeight="semibold" />
                    <p className="text-xs opacity-50 mt-2">{t("reservation.packSerenity.intro1")}</p>
                    <p className="text-xs opacity-50">{t("reservation.packSerenity.intro2")}</p>
                    <ul className="mt-3 text-xs opacity-50 list-disc ml-5 space-y-1">
                        <li>{t("reservation.packSerenity.bullets.0")}</li>
                        <li>{t("reservation.packSerenity.bullets.1")}</li>
                    </ul>
                </div>

                <div className="flex flex-col justify-between text-right self-stretch">
                    <div className="flex gap-2 items-center justify-end">
                        {showPrice ? (
                            <>
                                <div className="text-2xl font-extrabold text-main">{Number(pricePerDay).toFixed(0)}€</div>
                                <div className="text-sm opacity-60 leading-4">/&nbsp;{t("reservation.night")}</div>
                            </>
                        ) : (
                            <div className="text-sm opacity-60">{t("reservation.packSerenity.toDefine")}</div>
                        )}
                    </div>

                    <ButtonFit
                        className="mt-3"
                        onClick={onToggle}
                        disabled={disabled || !showPrice}
                        text={isAdded ? t("reservation.packSerenity.remove") : t("reservation.packSerenity.cta")}
                    />
                </div>
            </div>
        </div>
    );
}